import React, { useEffect, useState } from "react";
import "../styling/testimonial.css";
import engrAwolowo from '../assets/engr_awolowo.png';
import sodiqAkintomide from '../assets/sodiq_akintomide.png';
import engrOlusola from '../assets/engrSola.png';

const testimonialsData = [
  {
    // image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTF_IdW_JHgWJh_GBrudxZXPOFfdf5598pnew&s",
    image: engrAwolowo,
    quote: "The quality and attention to detail are unmatched. Highly recommend!",
    name: "Engr. Awolowo Olayiwola",
    rating: 4,
  },
  {
    // image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcREO17hg6KvLlweeZWN0LCEdi-OXM9qGpbQ9w&s",
    image: engrOlusola,
    quote: "This is an amazing service! It completely exceeded my expectations.",
    name: "Engr. Olusola Ayanda",
    rating: 5,
  },
  // {
  //   image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTcyI9Cvp53aaP9XeRn-ZKbJDH2QaWC72O26A&s",
  //   quote: "Incredible quality and a wonderful team to work with. Everything was handled with precision. 10/10 – I highly recommend their services!",
  //   name: "Mr Ridwan Afuape",
  //   rating: 5,
  // },
  {
    // image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTcyI9Cvp53aaP9XeRn-ZKbJDH2QaWC72O26A&s",
    image: sodiqAkintomide,
    quote: "A fantastic experience from start to finish.",

    name: "Sodiq Akintomide Muiliyu",
    rating: 5,
  },
];

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonialsData.length);
    }, 3000); // Slide every 3 seconds
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="font-Poppins testimonial-section w-full bg-gray-100 text-slate-900 py-12 dark:bg-slate-950 dark:text-gray-100">
      <h1 className="text-4xl font-bold text-center mb-4">Testimonials</h1>

      <div className="w-full flex justify-center items-center">
        <div className="h-1.5 w-36 bg-orange-500 mb-6 mt-6 rounded-lg"></div>
      </div>

      <div className="testimonial-container relative overflow-hidden w-full max-w-4xl mx-auto">
        <div
          className="flex transition-transform duration-800 ease-in-out"
          style={{
            transform: `translateX(-${currentIndex * 100}%)`,
          }}
        >
          {testimonialsData.map((testimonial, index) => (
            <div
              key={index}
              className="testimonial-card flex-shrink-0 w-full rounded-lg"
            >
              <div className="p-8 bg-gray-100 rounded-xl flex flex-col md:flex-row items-center dark:bg-slate-900">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-48 h-48 rounded-full object-cover mb-6 md:mb-0 md:mr-8"
                  loading="lazy"
                />
                <div className="testimonial-details text-center md:text-left">
                  <p className="text-gray-700 italic text-lg mb-4">
                    "{testimonial.quote}"
                  </p>
                  <h3 className="text-2xl font-semibold mb-2">
                    {testimonial.name}
                  </h3>
                  <div className="flex justify-center md:justify-start">
                    {Array.from({ length: testimonial.rating }).map((_, i) => (
                      <span key={i} className="text-orange-500 text-2xl">
                        ★
                      </span>
                    ))}
                    {Array.from({ length: 5 - testimonial.rating }).map(
                      (_, i) => (
                        <span key={i} className="text-gray-300 text-2xl">
                          ★
                        </span>
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
